import axios from "axios";
import React, { useState } from "react";
import { Card, Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import { API } from "../../api";

function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState("");
  const [success, setSucess] = useState(false);

  const myError = (msg) => {
    setError(`${msg}`);
    setTimeout(() => {
      setError("");
    }, 2000);
  };

  const handelValidate = () => {
    if (
      name.trim().length === 0 ||
      email.trim().length === 0 ||
      password1.trim().length === 0 ||
      password2.trim().length === 0
    ) {
      setError("Please Fill In All The Fields");
      setTimeout(() => {
        setError("");
      }, 2000);
      return false;
    }
    if (name.trim().length < 3 || name.trim().length > 12) {
      myError("Username Field Should Be Of 3 To 12 Character ");
      return false;
    }
    if (password1 !== password2) {
      myError("Passwords Field Didn't Match ");
      return false;
    }
    if (String(password1).trim().length < 8) {
      myError("Passwords Must Be Atleast oF 8 Character's ");
      return false;
    }
    return true;
  };

  const handelSignup = (e) => {
    e.preventDefault();
    if (handelValidate()) {
      axios
        .post(`${API}register/`, { username: name, email, password: password1 })
        .then((res) => {
          setSucess(true);
        })
        .catch((err) => {
          if (
            err.response.data.username[0] ===
            "A user with that username already exists."
          ) {
            myError("A user with that username already exists.");
          }
        });
    }
  };

  return (
    <div className="container p-5">
      {success ? (
        <div className="container">
          <div>
            <p className="text-center bg-danger py-3 text-white">
              Resgistration Successfull !!! <br />
              Please Click On &nbsp;
              <Link
                to="/login"
                className="my_active text-decoration-none text-dark"
              >
                Login
              </Link>
              &nbsp; To Log Into Your Account
            </p>
          </div>
        </div>
      ) : (
        <form onSubmit={handelSignup}>
          <Card>
            <Card.Header>Signup</Card.Header>
            <Card.Body>
              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="floatingusername"
                  placeholder="Username"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
                <label htmlFor="floatingusername">Username</label>
              </div>
              <div className="form-floating mb-3">
                <input
                  type="email"
                  className="form-control"
                  id="floatingemail"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
                <label htmlFor="floatingemail">Email</label>
              </div>
              <div className="form-floating mb-3">
                <input
                  type="password"
                  className="form-control"
                  id="floatingPassword1"
                  placeholder="Password"
                  value={password1}
                  onChange={(e) => {
                    setPassword1(e.target.value);
                  }}
                />
                <label htmlFor="floatingPassword1">Password</label>
              </div>
              <div className="form-floating">
                <input
                  type="password"
                  className="form-control"
                  id="floatingPassword2"
                  placeholder="Password"
                  value={password2}
                  onChange={(e) => {
                    setPassword2(e.target.value);
                  }}
                />
                <label htmlFor="floatingPassword2">
                  Confirm Password Again{" "}
                </label>
              </div>
              <Button type="submit" className="px-5 my-3 " variant="dark">
                Signup
              </Button>
              <div>
                {error ? <Alert variant="danger">{error}</Alert> : false}
                <p className="text-center">
                  Already A Member Of{" "}
                  <span style={{ color: "#e8491d" }}>SHOP</span>
                  YOU ?{" "}
                  <Link to="/login" className="my_active text-decoration-none">
                    Login
                  </Link>
                </p>
              </div>
            </Card.Body>
          </Card>
        </form>
      )}
    </div>
  );
}

export default Signup;
